import React, { useState, useEffect } from 'react';
import SwapperPopup from './SwapperPopup';
import StatsSidebar from './StatsSidebar';
import { getBalanceAndSymbol } from '../../functions/dexfunctions';
import { popupManager } from '../common/PopupManager';
import { swapTokens, getAmountOut } from '../../functions/factoryFunctions';
import { useParams } from "react-router-dom";
// Solana removed
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import flameIcon from '../../assets/trending2.png';
import { networkManager } from '../common/NetworkManager';
// Solana libs removed

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default function MiniSwapper({signer}) {
  const {chain,tokenAddress } = useParams();
  const [tradeDirection, settradeDirection] = useState('buying');
  const [selectedToken, setSelectedToken] = useState({symbol:"Select"}); // This will be the chosen token opposite ETH
  const [ethAmount, setethAmount] = useState("");
  const [tokenAmount, settokenAmount] = useState("");
  //const [provider, setProvider] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectingToken, setSelectingToken] = useState(null);
  const [featuredTokens, setfeaturedTokens] = useState([]);
  const [ethBalance,setethBalance] = useState(null)
  const [tokenBalance,settokenBalance] = useState(null)
  const [loadingTrade, setLoadingTrade] = useState(false);
  const [loadingToQuote,setloadingToQuote] = useState(false)
  const [loadingFromQuote,setloadingFromQuote] = useState(false)
  const [isSlippagePopupOpen, setIsSlippagePopupOpen] = useState(false);
  const defaultSlippage = 0.5;
  const [slippage, setslippage] = useState(defaultSlippage); // default slippage
  const [tempSlippage, setTempSlippage] = useState(defaultSlippage); // Temporary input state
  const [isWarningExpanded, setIsWarningExpanded] = useState(false);
  // derived impact, not shown in UI

  // Convert UI slippage (percent) to basis points expected by swapTokens
  const slippageBps = Math.max(0, Math.round(Number(slippage) * 100) || 0);


  function formatNumber(number) {
    const parsedNumber = parseFloat(number);

    if (isNaN(parsedNumber)) return "0.0";

    // Convert to string without formatting
    const plainStr = parsedNumber.toString().replace('.', '').replace('-', '');

    // If more than 10 digits, return in exponential notation
    if (plainStr.length > 17) {
      return parsedNumber.toExponential(2); // e.g., 1.23e+10
    }

    // Otherwise, return formatted normally
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(parsedNumber);
  }

     //sliding trending tokens settings
        // Only use slider if we have enough tokens to make it meaningful
     const shouldUseSlider = featuredTokens.length > 2;
     
     const settings = {
       arrows: false,
       dots: false,
       infinite: shouldUseSlider,
       speed: 800,               // Reduced from 1500 for smoother animation
       autoplay: shouldUseSlider,
       autoplaySpeed: 0,        
       cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)', // Changed from 'linear' for smoother easing
       slidesToShow: Math.min(3.5, featuredTokens.length),
       slidesToScroll: 1,
       pauseOnHover: false,
       swipe: shouldUseSlider,
       rtl: false,               // Ensure left-to-right direction
       responsive: [
         {
           breakpoint: 768,
           settings: {
             slidesToShow: Math.min(2.5, featuredTokens.length),
             speed: 600
           }
         }
       ]
     };

  const fromToken = tradeDirection === 'buying' ? 'ETH' : selectedToken.symbol;
  const toToken = tradeDirection === 'buying' ? selectedToken.symbol : 'ETH';
  
  const fromAmount = tradeDirection === 'buying' ? ethAmount : tokenAmount;
  const toAmount = tradeDirection === 'buying' ? tokenAmount : ethAmount;

const ethAddress = "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2";
const nativeSymbol = "ETH";

  const openSlippagePopup = () => {
    setIsSlippagePopupOpen(true);
    setTempSlippage(slippage)
  };

  const closeSlippagePopup = () => {
    setIsSlippagePopupOpen(false);
  };

  function chainParamToChainId(chainParam) {
    switch (chainParam) {
      case "ethereum":
        return 1;
      // add more if needed
      default:
        return null; // or 1 as a default
    }
  }

  const handleTempSlippageChange = (e) => {
    const value = parseFloat(e);
    
    if (e === "" || (!isNaN(value) && value >= 0.0 && value <= 100)) {
      setTempSlippage(e); // Use raw input value
    }
  };

  const handleSubmitSlippage = () => {
    if(tempSlippage === null || tempSlippage === 0 || tempSlippage === '' || tempSlippage === '0'){
      setslippage(defaultSlippage)
      setTempSlippage(defaultSlippage)
      closeSlippagePopup();
      return;
    }
    setslippage(tempSlippage); // Update parent state
    closeSlippagePopup();
  };



  const changeDirection = () => {
    // Toggle between buying and selling
    if (tradeDirection === 'buying') {
      settradeDirection('selling');
    } else {
      settradeDirection('buying');
    }
  };

  const fetchTokens = async () => {
    const response = await fetch(' https://qwertz.ink/vistadex/tokens?page=1&sort=fdv:DESC&chain='+chain);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    setfeaturedTokens(data.data);
  };

  useEffect(() => {
    fetchTokens();
    fetchETHBalance();
  }, [signer]);

  

  const refreshQuotes = async () =>{
    await fetchETHBalance();
    if(selectedToken && selectedToken.symbol && selectedToken.symbol !== 'Select'){
      await fetchTokenBalance(selectedToken);
    }
    if(tradeDirection === "buying"){
      handleETHChange(ethAmount)
    }
    else if(tradeDirection === "selling"){
      handleTokenChange(tokenAmount)
    }
  }
  const fetchETHBalance = async (token) => {
    try{
      if (signer) {
        let balances = await getBalanceAndSymbol(ethAddress,ethAddress,signer)
        setethBalance(balances)
      }
    }catch(e){
      //console.log(e)
    }
  }
  const fetchTokenBalance = async (token) => {
    try{
      //console.log(token.address)
      //console.log(ethAddress)
      //console.log(signer)
      //if (chain ===)
      let balances = await getBalanceAndSymbol(token.address,ethAddress,signer)
      //console.log(balances)
      settokenBalance(balances)
    }catch(e){
      //console.log(e)
    }
  }
  const handleSelectToken = (token) => {
    setSelectedToken(token);
    setIsPopupOpen(false);
    fetchTokenBalance(token)
    if(ethAmount>0 ){
      handleETHChange(ethAmount.toString(),true,token)
    }
    else if(tokenAmount>0  ){
      handleTokenChange(tokenAmount)
    }
  };

  const handleETHChange = async (amount,select,token) => {
    let tokenTarget;
    if(select === true){
      tokenTarget=token
    }else{
      tokenTarget = selectedToken
    }
    setethAmount(amount);
    if(tokenTarget.symbol === "Select"){
      return;
    }
    if(tradeDirection === "buying"){
      setloadingToQuote(true)
      let tokenCount = await getAmountOut(ethAddress,tokenTarget.address,amount,chain);
      //console.log(tokenCount)
      settokenAmount(tokenCount)
      setloadingToQuote(false)
    }
    else if(tradeDirection === "selling"){
      setloadingFromQuote(true)
      let tokenCount = await getAmountOut(ethAddress,tokenTarget.address,amount,chain);
      //console.log(tokenCount)
      settokenAmount(tokenCount)
      setloadingFromQuote(false)

    }
  }
  const handleTokenChange = async (amount) => {
    settokenAmount(amount);
    if(selectedToken.symbol === "Select"){
      return;
    }
    if(tradeDirection === "buying"){
      setloadingFromQuote(true)
      let tokenCount = await getAmountOut(selectedToken.address,ethAddress,amount,chain);
      //console.log(tokenCount)
      setethAmount(tokenCount)
      setloadingFromQuote(false)
    }
    else if(tradeDirection === "selling"){
      setloadingToQuote(true)
      let tokenCount = await getAmountOut(selectedToken.address,ethAddress,amount,chain);
      //console.log(tokenCount)
      setethAmount(tokenCount)
      setloadingToQuote(false)

    }
  }


  const SwapBuy = async () => {
    if (signer === null) {
      popupManager.addPopup({
        id: Date.now(),
        type: "error",
        message: "Please connect your wallet before buying tokens.",
        duration: 6000,
      });
      return;
    }

    // Use NetworkManager instead of manual validation
    const networkValidation = await networkManager.validateNetwork(signer, chain);
    if (!networkValidation.isValid) {
      return; // NetworkManager already shows the popup
    }

    let id = Date.now();

    try {
      setLoadingTrade(true)
      let tx_signer = signer;
      popupManager.addPopup({
        id: id,
        type: "message",
        message: "Swapping " + ethAmount + " "+nativeSymbol+" of " + selectedToken.address,
      });
 
      let buy = await swapTokens(
        ethAddress,
        selectedToken.address,
        fromAmount,
        tx_signer,
        slippageBps,
        chain
      );
      popupManager.removePopup(id);
      let successful_id = Date.now();

      popupManager.addPopup({
        id: successful_id,
        type: "success",
        message:
          "Transaction sent for " + fromAmount + " ETH of " + selectedToken.address,
      });
      setTimeout(() => {
        popupManager.removePopup(successful_id);
      }, 6000);
    } catch (e) {
      console.log(e)
      popupManager.removePopup(id);
      popupManager.addPopup({
        id: Date.now(),
        type: "error",
        message: "" + e.toString(),
        duration: 6000,
      });
    }finally{
      setLoadingTrade(false)

    }
  };
  const SwapSell = async () => {
    
    if (signer === null) {
      popupManager.addPopup({
        id: Date.now(),
        type: "error",
        message: "Please connect your wallet before buying tokens.",
        duration: 6000,
      });
      return;
    }

    // Use NetworkManager instead of manual validation
    const networkValidation = await networkManager.validateNetwork(signer, chain);
    if (!networkValidation.isValid) {
      return; // NetworkManager already shows the popup
    }

    let id = Date.now();

    try {
      setLoadingTrade(true)

      let tx_signer = signer;
      popupManager.addPopup({
        id: id,
        type: "message",
        message: "Swapping " + toAmount + " of " + selectedToken.address,
      });

      let sell = await swapTokens(
        selectedToken.address,
        ethAddress,

        fromAmount,
        tx_signer,
        slippageBps,
        chain
      );

      popupManager.removePopup(id);
      let successful_id = Date.now();

      popupManager.addPopup({
        id: successful_id,
        type: "success",
        message:
          "Successfully Swapped " + toAmount + " of " + selectedToken.address,
      });
      setTimeout(() => {
        popupManager.removePopup(successful_id);
      }, 6000);
    } catch (e) {
      //console.log(e)
      popupManager.removePopup(id);
      popupManager.addPopup({
        id: Date.now(),
        type: "error",
        message: "" + e.toString().replace(/Uniswap/gi, "Ethervista"),
        duration: 6000,
      });
    } finally{
      setLoadingTrade(false)
    }
  };

  const SwapSend = async () => {
    if (tradeDirection==="buying"){
        SwapBuy()
    }else if(tradeDirection==="selling"){
        SwapSell()
    }
  }

  // Function to determine transaction path based on chain and whether native token is being swapped FROM
  const getTransactionPath = () => {
    if (!selectedToken || selectedToken.symbol === "Select") {
      return null;
    }

    const isSwappingFromNative = tradeDirection === "buying"; // When buying, we're swapping FROM native token

    if (isSwappingFromNative) {
      return ["1. Swap ETH for Tokens"];
    }
    return ["1. Approve DEX (Once)", "2. Swap Tokens for ETH"];
  };

  const transactionPath = getTransactionPath();

  return (
    <div className="fixed inset-0 flex items-center justify-center z-10">
      <div className="rounded-xl p-2 py-2 w-full max-w-[552px] mx-auto">
        <h1 className='kanit-light  text-[35px] font-[500] mt-2 mb-6 flex justify-center text-start hidden '>
          
          Swap Anything. <br/> Anytime.<br/>  With the #1 Fee Protocol
          <div className="relative group ">
            <svg
              className="w-4 h-4 text-gray-400/70 hover:text-gray-400 cursor-pointer"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M18 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zM9 7v2h2V7H9zm0 4v4h2v-4H9z" />
            </svg>
            <div
              className="absolute top-full left-1/2 transform -translate-x-1/2  w-64 p-2 bg-[#0e1018] border border-white/15 text-white text-xs rounded-lg 
              hidden group-hover:block transition-opacity duration-200 font-[300] z-20 text-white/90 px-4"
            >
              Ethervista operates as an automated market maker (AMM), facilitating decentralized token swaps using liquidity pools provided by users. When executing a swap, the price is dynamically adjusted based on the pool's token ratio, which can lead to slippage. Slippage represents the difference between the expected price and the actual price received during a trade—higher slippage tolerance means accepting a less favorable rate to complete the swap. On Ethervista, every swap incurs an ETH fee that is distributed directly to projects as revenue and to liquidity providers as rewards, ensuring sustainable incentives for all participants.
            </div>
          </div>
          </h1>
               {/* Stats Sidebar - Alternative Display */}
         {chain === 'ethereum' && (
           <StatsSidebar featuredTokens={featuredTokens} />
         )}

                                 {/* Complete Interface Container */}
           <div className="relative rounded-2xl animate-slideFadeIn">
            <div className="bg-[#0e1018] rounded-2xl p-6">
             {/* Trending Tokens */}
             {chain === 'ethereum' && (
             <div className='flex items-center w-full p-3 bg-gradient-to-r from-white/5 to-white/3 rounded-xl animate-slideFadeIn mb-3'>
               <div className='pr-6 inter-500 font-[700] text-[14px] flex items-center'>
                 <img
                   src={flameIcon}
                   alt="flame"
                   className="w-4 h-4 mr-2 [filter:drop-shadow(0_0_6px_rgba(253,224,71,0.6))]"
                 />
                 <span className="bg-gradient-to-b text-white from-yellow-100/90 to-yellow-100 bg-clip-text text-transparent [text-shadow:0_0_6px_rgba(253,224,71,0.6)]">
                   Trending
                 </span>
               </div>

               {shouldUseSlider ? (
                 <Slider 
                   className="flex-1 overflow-hidden animate-slideFadeIn" 
                   style={{
                     willChange: 'transform',
                     backfaceVisibility: 'hidden',
                     perspective: '1000px'
                   }}
                   {...settings}
                 >
                   {featuredTokens.slice(0, 10).map((token, index) => (
                     <Link
                       key={token.address}
                       target="_blank"
                       to={`/${chain}/token/${token.address}`}
                       className="mx-2 inline-block rounded-lg transition-all duration-300 ease-out hover:bg-white/5 hover:scale-105 px-3 py-2"
                       style={{
                         willChange: 'transform',
                         backfaceVisibility: 'hidden'
                       }}
                     >
                       <div className="inline-flex items-center font-semibold text-sm text-[#eaeaeae0] hover:text-[#ffffffe0] transition-all duration-300 ease-out">
                         <p className="text-[12px] font-normal pr-2 text-[#f7f7f7e0]">#{index + 1}</p>
                         <img
                           alt={token.name}
                           className="w-5 h-5 rounded-full opacity-85 mr-2 transition-all duration-300 ease-out hover:opacity-100"
                           src={token.logo}
                           style={{
                             willChange: 'opacity'
                           }}
                         />
                         <p className="text-[12px] text-[#ffffffe0] inter-500 font-[500] whitespace-nowrap">
                           {token.symbol.toUpperCase().slice(0, 6)}
                         </p>
                       </div>
                     </Link>
                   ))}
                 </Slider>
               ) : (
                 // Static display for 1-2 tokens
                 <div className="flex-1 flex gap-2 animate-slideFadeIn">
                   {featuredTokens.slice(0, 10).map((token, index) => (
                     <Link
                       key={token.address}
                       target="_blank"
                       to={`/${chain}/token/${token.address}`}
                       className="inline-block rounded-lg transition-all duration-300 ease-out hover:bg-white/5 hover:scale-105 px-3 py-2"
                     >
                       <div className="inline-flex items-center font-semibold text-sm text-[#eaeaeae0] hover:text-[#ffffffe0] transition-all duration-300 ease-out">
                         <p className="text-[12px] font-normal pr-2 text-[#f7f7f7e0]">#{index + 1}</p>
                         <img
                           alt={token.name}
                           className="w-5 h-5 rounded-full opacity-85 mr-2 transition-all duration-300 ease-out hover:opacity-100"
                           src={token.logo}
                         />
                         <p className="text-[12px] text-[#ffffffe0] inter-500 font-[500] whitespace-nowrap">
                           {token.symbol.toUpperCase().slice(0, 6)}
                         </p>
                       </div>
                     </Link>
                   ))}
                 </div>
               )}
               
             </div>
             )}
            {/* Rest of the component remains the same */}
            <div className='flex justify-between w-full pt-6 animate-slideFadeIn'>
              <div className='flex items-center'>
                
                <button onClick={openSlippagePopup} className='border border-white/5  justify-center items-center flex rounded-full bg-white/5 hover:bg-[#ffffff09] w-8 h-6 mb-3'>
                  <img src='/settings.svg' alt="settings" className="w-[11px] h-[11px] mx-[3px] text-white opacity-85" />
                </button>
                <span className='ml-2 text-white/80 inter-500 font-[500] text-xs mb-3'>({slippage}%)</span>
              </div>
              <button onClick={refreshQuotes} className='border border-white/5 justify-center items-center flex rounded-full bg-white/5 hover:bg-[#ffffff09] w-8 h-6 mb-3'>
                <img src='/refresh2.svg' alt="refresh" className="w-[10px] h-[10px] text-white opacity-85" />
              </button>
            </div>

            {/* From Amount */}
            <div className='p-1 border-t border-l border-white/5 rounded-xl pt animate-slideFadeIn'>
            <div className="bg-gradient-to-b from-[#ffffff09] to-[#ffffff05] border border-white/10 transition-color hover:border-yellow-100/50 hover:from-yellow-200/5 hover:to-yellow-200/10 hover:shadow-[0_0_10px_rgba(250,255,191,0.2),0_0_20px_rgba(195,193,126,0.25),0_0_30px_rgba(250,255,191,0.15)] shadow-[-5px_5px_15px_rgba(255,255,255,0.07)] rounded-xl p-6  py-5 transition-shadow duration-300">
              <div className="flex justify-between items-center ">
                <span className="text-white inter-600 font-[600] text-sm">
                  {tradeDirection === 'buying' ? 'From' : 'From'}
                </span>
                {/* Clickable Balance */}
                <span
                  className="text-white/90 inter-500 font-[500] text-sm cursor-pointer"
                  onClick={() => {
                    if (tradeDirection === 'buying') {
                      // Use full ETH balance
                      handleETHChange(ethBalance, false, null);
                    } else {
                      // Use full token balance
                      if (tokenBalance) {
                        handleTokenChange(tokenBalance);
                      }
                    }
                  }}
                >
                  Balance {tradeDirection === "buying"
                    ? !isNaN(ethBalance) && Math.round(ethBalance * 1000) / 1000
                    : tokenBalance
                      ? tokenBalance
                      : 0
                  }
                </span>
              </div>

              <div className="flex items-center mt-4">
                {loadingFromQuote === true ? (
                  <div className="flex-1 bg-transparent text-start text-white text-2xl focus:outline-none">
                    <div className='bg-white/10 animate-pulse h-6 w-56'></div>
                  </div>
                ) : (
                  <input
                    type="number"
                    value={fromAmount}
                    onWheel={e => e.target.blur()}  
                    onChange={(e) => {
                      if (tradeDirection === 'buying') {
                        handleETHChange(e.target.value, false, null);
                      } else {
                        handleTokenChange(e.target.value);
                      }
                    }}
                    className="flex-1 font-[600] bg-transparent w-24 sm:w-full text-white/80 text-[22px] focus:outline-none"
                    placeholder="0"
                  />
                )}
                {/* If fromToken is ETH, show ETH icon; otherwise, show token icon */}
                <button
                  onClick={() => {
                    // Only open popup if tradeDirection is 'selling' and we need to select the token to sell.
                    if (tradeDirection === 'selling') {
                      setSelectingToken('from');
                      setIsPopupOpen(true);
                    }
                  }}
                  className="flex items-center text-white inter-600 font-[600] text-sm border-white/20 px-4 py-2 rounded-full hover:bg-yellow-100/10  transition-colors hover:shadow-[0_0_15px_5px_rgba(253,224,71,0.1)] duration-300 border-[1px] hover:border-yellow-100/50"
                >
                  {!(tradeDirection ==="selling" && selectedToken.symbol==="Select") && (
                    <img
                      src={tradeDirection === 'buying' ? "/eth.svg" : selectedToken.logo}
                      alt=""
                      className="w-5 h-5 mr-2 rounded-full"
                    />
                  )}
                  {fromToken}
                  {tradeDirection === 'selling' && (
                    <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
                      <path
                        fillRule="evenodd"
                        d="M10 14l-5-5h10l-5 5z"
                        clipRule="evenodd"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>
            </div>

            {/* Swap Button */}
            <div className="flex justify-center my-2 z-10 animate-slideFadeIn">
              <button
                onClick={changeDirection}
                className="p-2 bg-white/5 hover:bg-white/10 transition-colors hover:shadow-[0_0_15px_5px_rgba(253,224,71,0.1)] duration-300 border-white/5 border-[1px] hover:border-yellow-300/50 rounded-full text-white/50 focus:outline-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 transform"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  {/* Arrows icon */}
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M16 17l-4 4m0 0l-4-4m4 4V3"
                  />
                </svg>
              </button>
            </div>

            {/* To Amount */}
                  <div className='p-1 border-t border-l border-white/5 rounded-xl mb-6 animate-slideFadeIn'>

          <div className="bg-gradient-to-b from-[#ffffff09] to-[#ffffff05] border hover:from-yellow-200/5 hover:to-yellow-200/10  border-white/10 transition-color hover:border-yellow-100/50 hover:shadow-[0_0_10px_rgba(250,255,191,0.2),0_0_20px_rgba(195,193,126,0.25),0_0_30px_rgba(250,255,191,0.15)] shadow-[-5px_5px_15px_rgba(255,255,255,0.07)] rounded-xl p-6  py-5 transition-shadow duration-300">
        <div className="flex justify-between items-center">
          <span className="text-white font-[600] text-sm">
            {tradeDirection === 'buying' ? 'Buying (Token)' : `Buying (${nativeSymbol})`}
          </span>

          {/* Clickable Balance */}
          <span
            className="text-white/90 inter-500 font-[500] text-sm cursor-pointer"
            onClick={() => {
              if (tradeDirection === 'selling') {
                // Use full ETH balance
                handleETHChange(ethBalance, false, null);
              } else {
                // Use full token balance
                if (tokenBalance) {
                  handleTokenChange(tokenBalance);
                }
              }
            }}
          >
            Balance {tradeDirection === "selling"
              ? !isNaN(ethBalance) && Math.round(ethBalance * 1000) / 1000
              : tokenBalance
                ? tokenBalance
                : 0
            }
          </span>
        </div>

        <div className="mt-4 flex items-center">
          {loadingToQuote === true ? (
            <div className="flex-1 bg-transparent text-start text-white text-2xl focus:outline-none">
              <div className="bg-white/10 animate-pulse h-6 w-56"></div>
            </div>
          ) : (
            <input
              type="number"
              value={toAmount}
              onWheel={e => e.target.blur()}  
              onChange={(e) => {
                if (tradeDirection === 'buying') {
                  handleTokenChange(e.target.value);
                } else {
                  handleETHChange(e.target.value, false, null);
                }
              }}
              className="flex-1 font-[600] bg-transparent w-24 sm:w-full text-white/80 text-[22px] focus:outline-none"
              placeholder="0"
            />
          )}

          {/* If toToken is ETH, show ETH icon; otherwise, show token icon */}
          <button
            onClick={() => {
              // Only open popup if tradeDirection is 'buying' since we are selecting which token to buy.
              if (tradeDirection === 'buying') {
                setSelectingToken('to');
                setIsPopupOpen(true);
              }
            }}
            className="flex items-center border-white/20 text-white font-[600] text-sm px-4 py-2 rounded-full transition-colors hover:bg-yellow-100/10 hover:shadow-[0_0_15px_5px_rgba(253,224,71,0.1)] duration-300 border-[1px] hover:border-yellow-100/50"
          >
            {!(tradeDirection === "buying" && selectedToken.symbol === "Select") && (
              <img
                src={tradeDirection === 'selling' ? "/eth.svg" : selectedToken.logo}
                alt=""
                className="w-5 h-5 mr-2 rounded-full"
              />
            )}
            {toToken}
            {tradeDirection === 'buying' && (
              <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 14l-5-5h10l-5 5z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </button>
        </div>
        </div>
          </div>

            {/* Transaction Path Indicator */}
            {transactionPath && signer && (
              <div className="mt-3 mb-2 p-3 bg-white/5 border border-white/10 rounded-lg">
                <div className="flex items-center gap-2 mb-2">
                  <svg className="w-4 h-4 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="text-white/80 text-sm font-medium">Transaction Path</span>
                </div>
                <div className="space-y-1">
                  {transactionPath.map((step, index) => (
                    <div key={index} className="flex items-center gap-2 text-white/70 text-xs">
                      <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                      <span>{step}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Swap Action Button */}
            {signer !== null ? 
            <button
              onClick={SwapSend}
              className="animate-slideFadeIn w-full mt-5 text-[16px] font-[600] text-white  bg-gradient-to-r from-[#faffbfb5] via-[#c3c17e] to-[#faffbfb5]
  hover:brightness-110 border border-white/60 hover:border-white/90 transition  duration-300 py-2 px-4 rounded-xl focus:outline-none"
            >
              Swap
            </button>   :
            <button
              //onClick={}
              className="animate-slideFadeIn w-full mt-5 text-[16px] font-[600] text-white  bg-gradient-to-r from-[#faffbfb5] via-[#c3c17e] to-[#faffbfb5]
  hover:brightness-110 border border-white/60 hover:border-white/90 transition  duration-300 py-2 px-4 rounded-xl focus:outline-none"
            >
              Connect
            </button>  
            }

            {/* Warning Section */}
            <div className="mt-3">
              <button
                onClick={() => setIsWarningExpanded(true)}
                className="w-full flex items-center justify-between text-left"
              >
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                  </svg>
                  <span className="text-yellow-400 text-sm font-medium">If your swap failed, it's more likely due to:</span>
                </div>
                <svg 
                  className="w-4 h-4 text-yellow-400"
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div className='hidden'>
          <div className='inter-400 font-[400] text-start text-gray-400 pt-8'>Total Swaps: 2404 </div>
          <div className='inter-400 font-[400] text-start text-gray-400'>Yearly Token Revenue (USD): 12,329.23$ </div>
          <div className='inter-400 font-[400] text-start text-gray-400'>Yearly Token Revenue (USD): 429,329.23$ </div>
          <div className='inter-400 font-[400] text-start text-gray-400'>Average Fixed Fee Rate (USD): 5.00$ </div>
        </div>
        {/* SwapperPopup */}
        {isPopupOpen &&
        <SwapperPopup
          tokens={featuredTokens}
          onSelect={handleSelectToken}
          onClose={() => setIsPopupOpen(false)}
          isOpen={isPopupOpen}
          chain={chain}
        />}
        {isSlippagePopupOpen && (
          <div className="fixed inset-0 z-[9998] flex items-center justify-center">
            {/* Overlay */}
            <div
              className="absolute inset-0 bg-black/70"
              onClick={closeSlippagePopup}
            ></div>

            {/* Popup Content */}
            <div className="relative bg-[#0e1018] rounded-xl p-6 z-10 w-full max-w-sm shadow-lg">
              <button
                onClick={closeSlippagePopup}
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 font-bold"
              >
                ×
              </button>

              <div className="flex items-center mb-4">
                <h2 className="text-[18px] kanit-light font-[400] text-white">Slippage</h2>
                <div className="relative group ml-2">
                  <span className="w-4 h-4 text-[10px] leading-none flex items-center justify-center rounded-full border border-white/30 text-white/80">?</span>
                  <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-64 bg-black border border-[#333] text-xs text-[#bdbdbd] rounded-lg px-3 py-2 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-50">
                    Slippage is the maximum price change you allow between quote and execution. A higher value makes a trade more likely to go through, but you may receive a worse rate. For volatile tokens, use a slightly higher slippage.
                  </div>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <input
                  type="number"
                  value={tempSlippage}
                  onWheel={e => e.target.blur()}   
                  onChange={(e)=>{handleTempSlippageChange(e.target.value)}}
                  min="0"
                  max="100"
                  step="0.01"
                  className="w-full p-2 bg-transparent text-white kanit-light border border-white/20  transition-color duration-300 hover:border-yellow-300/50 hover:shadow-[0_0_15px_5px_rgba(253,224,71,0.2)] rounded-md focus:outline-none"
                  placeholder="Enter slippage (0.01 - 100)"
                />
                <span className="text-sm text-white font-semibold">%</span>
              </div>
              <div className="flex justify-end mt-4">
                <button
                  onClick={handleSubmitSlippage}
                  className="px-4 py-2 w-full text-white bg-white/5 hover:bg-white/10 border border-white/10 rounded-md font-semibold transition duration-300"
                >
                  Set
                </button>
              </div>
            </div>
          </div>
        )}

        {isWarningExpanded && (
          <div className="fixed inset-0 z-[9998] flex items-center justify-center">
            {/* Overlay */}
            <div
              className="absolute inset-0 bg-black/70"
              onClick={() => setIsWarningExpanded(false)}
            ></div>

            {/* Popup Content */}
            <div className="relative bg-[#0e1018] rounded-xl p-6 z-10 w-full max-w-md shadow-lg">
              <button
                onClick={() => setIsWarningExpanded(false)}
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 font-bold"
              >
                ×
              </button>

              <div className="flex items-center gap-2 mb-4">
                <svg className="w-5 h-5 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
                <h2 className="text-[18px] kanit-light font-[400] text-white">Common Swap Issues</h2>
              </div>
              
              <div className="space-y-4 text-white/80 text-sm">
                <div className="flex">
                  <span className="text-yellow-400 font-semibold w-4 flex-shrink-0">1.</span>
                  <div>
                    <strong>Insufficient amount (≤ $25)</strong> – Swaps under $25 often fail because they don't cover project-custom fees. Ensure your swap amount covers these fees, or that you'll still receive enough on the sell side after fees.
                  </div>
                </div>
                <div className="flex">
                  <span className="text-yellow-400 font-semibold w-4 flex-shrink-0">2.</span>
                  <div>
                    <strong>Slippage too low</strong> – Low slippage tolerance can cause failures if prices change mid-transaction. Adjust your tolerance via the Settings icon.
                  </div>
                </div>
                <div className="flex">
                  <span className="text-yellow-400 font-semibold w-4 flex-shrink-0">3.</span>
                  <div>
                    <strong>Low ETH or SOL balance</strong> – Each project sets its own fees, so make sure you have enough to cover them.
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}


      </div>
    </div>
  );
}

